<script>
import {pieChart, columnChart, barChart} from "./data-main-axes";

export default {
  props:{
    data: {
      type: Object,
    }
  },
  data() {
    return {
      // Chart
      columnChart: columnChart,
      barChart: barChart,
      pieChart: pieChart,
    };
  },
  computed:{
  },
  methods: {
    updateChart(){
      this.columnChart.chartOptions.xaxis.categories = this.data.columnChart.provinces;
    }
  },
  watch: {
    data: {
    handler(newData) {
      this.updateChart(newData);
    },
    deep: true, // 👈 لجعل `watch` يراقب تغييرات داخل الكائن أيضًا
    immediate: true // 👈 تشغيله مباشرة عند تحميل المكون
  },
  },
  created(){
  },
};
</script>

<template>
  <div>

      <div class="row">
        <div class="col-lg-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">التحصيل الدراسي</h4>
              <!-- Bar Chart -->
              <apexchart
                class="apex-charts barChart"
                height="350"
                type="bar"
                dir="ltr"
                :series="data.barChart_series"
                :options="barChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        
        <div class="col-lg-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">اعمار المتقدمين</h4>
              <!-- Pie Chart -->
              <apexchart
                class="apex-charts pieChart"
                height="380"
                type="pie"
                dir="rtl"
                :series="data.pieChart_series"
                :options="pieChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">المحافظات</h4>
              <!-- Column Charts -->
              <apexchart
                class="apex-charts columnChart"
                height="350"
                type="bar"
                dir="rtl"
                :series="data.columnChart.series"
                :options="columnChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>

  </div>

</template>